module.exports = __webpack_public_path__ + "img/262-hawaii.d8339d25.svg";